export default __webpack_public_path__ + "static/sdg-7-eb94370ebea6cb26512db116d266f665.png";